import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import C_ProtectedRoutes from "./C_ProtectedRoute";

import LoadingScreen from "@/components/state-pages/LoadingScreen";
import { ROUTES } from "@/constants/routes_sidebar/routes-constant";

const Page404 = React.lazy(() => import("@/pages/Page404"));
const C_Dashboard = React.lazy(
  () => import("@/pages/customer-portal/dashboard/page"),
);
const C_DocketPage = React.lazy(() => import("@/pages/customer-portal/docket"));
const C_SupportPage = React.lazy(
  () => import("@/pages/customer-portal/support"),
);
const CustomerLoginPage = React.lazy(
  () => import("@/pages/customer-portal/auth/login"),
);
const Invoices = React.lazy(
  () => import("@/pages/customer-portal/invoices/page"),
);
const MultiPortal = React.lazy(
  () => import("@/pages/customer-portal/auth/multi-portal"),
);
const Projects = React.lazy(
  () => import("@/pages/customer-portal/projects/page"),
);
const UserManagement = React.lazy(
  () => import("@/pages/customer-portal/user-management/page"),
);
const VerifyCustomer = React.lazy(
  () => import("@/pages/customer-portal/auth/Verify_Customer"),
);
const VerifyCustomerUser = React.lazy(
  () => import("@/pages/customer-portal/auth/Verify_C_User"),
);
const WareHousing = React.lazy(
  () => import("@/pages/customer-portal/ware-housing/page"),
);
const WasteManagement = React.lazy(
  () => import("@/pages/customer-portal/waste-management/page"),
);

const UnderConstructing = React.lazy(
  () => import("@/components/state-pages/UnderConstructing"),
);

const CustomerRoutes = (): React.JSX.Element => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path='/login/:token?' element={<CustomerLoginPage />} />
        <Route
          path='/verify-customer-user/:token/:userId/:isLogin?'
          element={<VerifyCustomerUser />}
        />{" "}
        <Route
          path='/verify-customer/:token/:customerId'
          element={<VerifyCustomer />}
        />
        <Route element={<C_ProtectedRoutes />}>
          <Route
            path={`${ROUTES.ROOT}`}
            element={<UnderConstructing title='Task' />}
          />
          <Route path={`/multi-portal`} element={<MultiPortal />} />{" "}
          <Route
            path={`${ROUTES.TASKS}`}
            element={<UnderConstructing title='Task' />}
          />
          <Route
            path={`${ROUTES.USER_MANAGEMENT}`}
            element={<UserManagement />}
          />
          <Route path={`${ROUTES.PROJECTS}`} element={<Projects />} />{" "}
          <Route path={`${ROUTES.INVOICING}`} element={<Invoices />} />{" "}
          <Route path={`${ROUTES.WORK_DOCKET}`} element={<C_DocketPage />} />{" "}
          <Route path={`${ROUTES.WASTE}`} element={<WasteManagement />} />{" "}
          <Route path={`${ROUTES.WARE_HOUSING}`} element={<WareHousing />} />{" "}
          <Route path={`${ROUTES.SUPPORT}`} element={<C_SupportPage />} />{" "}
          <Route path={`${ROUTES.DASHBOARD}`} element={<C_Dashboard />} />
        </Route>
        <Route path='*' element={<Page404 />} />
      </Routes>
    </Suspense>
  );
};

export default CustomerRoutes;
